/**
 * EscPosCommands — desktop port of BigxBookApp/src/printing/engine/EscPosCommands.ts.
 * Thin ESC/POS byte builders. Pure functions, no I/O.
 */

import { sanitizeForAscii } from './PrintableSanitizer';

const ESC = 0x1b;
const GS = 0x1d;

const toBytes = (arr: number[]): Uint8Array => new Uint8Array(arr);

const textBytes = (value: string): Uint8Array => {
  const sanitized = sanitizeForAscii(value);
  const out: number[] = [];
  for (let i = 0; i < sanitized.length; i++) {
    out.push(sanitized.charCodeAt(i));
  }
  return toBytes(out);
};

const concat = (...buffers: Uint8Array[]): Uint8Array => {
  const size = buffers.reduce((sum, b) => sum + b.length, 0);
  const merged = new Uint8Array(size);
  let offset = 0;
  buffers.forEach((b) => {
    merged.set(b, offset);
    offset += b.length;
  });
  return merged;
};

export const escPos = {
  init: (): Uint8Array => toBytes([ESC, 0x40]),
  alignLeft: (): Uint8Array => toBytes([ESC, 0x61, 0x00]),
  alignCenter: (): Uint8Array => toBytes([ESC, 0x61, 0x01]),
  alignRight: (): Uint8Array => toBytes([ESC, 0x61, 0x02]),
  boldOn: (): Uint8Array => toBytes([ESC, 0x45, 0x01]),
  boldOff: (): Uint8Array => toBytes([ESC, 0x45, 0x00]),
  feed: (n = 1): Uint8Array => toBytes([ESC, 0x64, Math.max(0, Math.min(255, n))]),
  cut: (): Uint8Array => toBytes([GS, 0x56, 0x41, 0x00]),
  textLine: (value: string): Uint8Array => concat(textBytes(value), toBytes([0x0a])),
  concat,
};
